import React from "react"
import { StaticQuery, graphql, withPrefix } from 'gatsby'
import { FormattedMessage, injectIntl } from 'react-intl'
import { Link } from './localizedlink'
import { slugify, filterLocalizedField } from '../utils'

const Speaker = ({intl: { locale }}) => (
    <StaticQuery
        query={graphql`
            query {
                speakers: allSpeakerYaml(sort: {fields: index}, filter: {index: {ne: null}}){
                    edges{
                      node{
                        title
                        jobtitle
                        img
                        workshop
                        casestudy
                        presentazione
                        keynote
                        lang
                      }
                    }
                }
            }
        `}
        render={data => {
            const speakers = filterLocalizedField(data.speakers, locale);
            return (
                <section id="speaker" className="section text-center speaker clearfix" aria-labelledby="region-speaker">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12 col-md-8 col-md-offset-2">
                                <h1 id="region-speaker" className="section__title">
                                    <FormattedMessage id="speaker"/>
                                </h1>
                                {speakers.map((speaker, i) => (
                                    <React.Fragment key={speaker.title}>
                                        <div className={`person ${i % 2 === 0 ? 'left' : 'right'}`} data-aos="fade-up">
                                            <Link to={`/${slugify(speaker.title)}/`} title={speaker.title} className="person__link">
                                                <figure className="person__figure">
                                                    <img src={withPrefix(speaker.img)} alt={speaker.title} className="person__img" />
                                                    <div className="person__bullet">
                                                        {speaker.casestudy && <span className="casestudy"></span>}
                                                        {speaker.keynote && <span className="keynote"></span>}
                                                        {speaker.workshop && <span className="workshop"></span>}
                                                        {speaker.presentazione && <span className="presentazione"></span>}
                                                    </div>
                                                    <div className="person__program">
                                                        {speaker.casestudy && <span className="casestudy"><FormattedMessage id="casestudy"/></span>}
                                                        {speaker.keynote && <span className="keynote"><FormattedMessage id="keynote"/></span>}
                                                        {speaker.workshop && <span className="workshop"><FormattedMessage id="workshop"/></span>}
                                                        {speaker.presentazione && <span className="presentazione"><FormattedMessage id="presentazione"/></span>}
                                                    </div>
                                                </figure>
                                                <span className="person__name">{speaker.title}</span>
                                                <span className="person__role">{speaker.jobtitle}</span>
                                                <span className="person__detail"><FormattedMessage id="continua>"/></span>
                                            </Link>
                                        </div>
                                        {i % 2 === 1 && <div className="clear"></div>}
                                    </React.Fragment>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>
            )}
        }
    />
);

export default injectIntl(Speaker);